import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from '../../../utilities/classNames';
import { format } from '../../../utilities/time';

const toPercentage = (value, of) => (value / of) * 100 + '%';

const mouseDistance = (e) => {
  const { left, width } = e.currentTarget.getBoundingClientRect();
  let mousePosition = e.pageX - left;
  if (mousePosition > width) {
    mousePosition = width;
  }

  return mousePosition / width;
};

const TimeLineGreen = ({
  className,
  duration = 0,
  time = 0,
  onSkip = () => {},
}) => {
  const [hover, setHover] = useState({ show: false, time: 0 });

  return (
    <div className={cn('TimeLine__track', {}, className)}>
      <div
        className={cn('TimeLine__hover-track', {
          active: hover.show,
        })}
        role="presentation"
        onClick={() => onSkip(hover.time)}
        onMouseEnter={() => setHover((hover) => ({ ...hover, show: true }))}
        onMouseMove={(e) => {
          const distance = mouseDistance(e);
          const time = distance * duration;
          setHover((hover) => ({ ...hover, time }));
        }}
        onMouseLeave={() => setHover((hover) => ({ ...hover, show: false }))}
      >
        <div
          className={cn('TimeLine__hover-info', { visible: hover.show })}
          style={{ left: toPercentage(hover.time, duration) }}
        >
          <div
            className={cn('TimeLine__hover-notch', {
              inverted: hover.time < time,
            })}
          />
          <div className="TimeLine__hover-time bold">{format(hover.time)}</div>
        </div>
      </div>
      <div
        className="TimeLine__scrubbed background-green"
        style={{ width: toPercentage(time, duration) }}
      ></div>
      {time < duration - 2 && (
        <div className="progress-circle green background-clear"></div>
      )}
      {time > duration - 2 && (
        <div className="progress-circle green background-green"></div>
      )}
    </div>
  );
};

TimeLineGreen.propTypes = {
  className: PropTypes.string,
  duration: PropTypes.number,
  time: PropTypes.number,
  onSkip: PropTypes.func,
};

export default TimeLineGreen;
